import {
  ADMIN_FILE_IMPORT_RESULT_LOADED,
  ADMIN_FILE_IMPORT_RESULT_CLEAR,
  ADMIN_FILE_IMPORTS_LOADED,
  ADMIN_FILE_IMPORTS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  fileImportResult: null,
  fileImports: null,
};

function adminFileImports(state = initialState, action) {
  switch (action.type) {
    case ADMIN_FILE_IMPORT_RESULT_LOADED:
      return {
        ...state,
        fileImportResult: action.payload.result,
      };
    case ADMIN_FILE_IMPORT_RESULT_CLEAR:
      return {
        ...state,
        fileImportResult: null,
      };
    case ADMIN_FILE_IMPORTS_LOADED:
      return {
        ...state,
        fileImports: action.payload.imports,
      };
    case ADMIN_FILE_IMPORTS_CLEAR:
      return {
        ...state,
        fileImports: null,
      };
    default:
      return state;
  }
}

export default adminFileImports;
